import React from 'react'
import {TitleTop, TitleBottom} from './styles'

const Title = () => (
  <>
    <TitleTop>Shower</TitleTop>
    <TitleBottom>Thoughts</TitleBottom>
  </>
)

export default Title
